import { createContext, useContext } from "react";
const AvatarContext = createContext(void 0);
const useAvatarContext = () => {
  const ctx = useContext(AvatarContext);
  if (!ctx)
    throw new Error("Avatar compound components must be used within <Avatar.Root>");
  return ctx;
};
export {
  AvatarContext,
  useAvatarContext
};
